export {
  DsIcon,
  DsButton,
  DsCard,
  DsPageHeader,
  DsLabel,
  DsInput,
  DsBadge,
  DsAlert,
  DsSpinner,
  DsEmptyState,
} from "./components";
export { ICON_SIZE, ICON_STROKE, TYPE_SCALE, FONT_WEIGHTS, COLOR_ROLES } from "./tokens";
export {
  PRODUCT_THEMES,
  DEFAULT_PRODUCT_THEME_ID,
  PRODUCT_THEME_STORAGE_KEY,
  PRODUCT_THEME_CHANGED_EVENT,
  applyProductTheme,
  initProductTheme,
  readStoredProductThemeId,
  refreshProductThemeForColorScheme,
} from "./themes";
export { default as ProductThemePicker } from "./ProductThemePicker";
export { default as ProductThemeFab } from "./ProductThemeFab";

/** Canonical Admin module page layout class names (see index.css `.ds-page-*`). */
export const PAGE_LAYOUT = {
  page: "ds-page",
  shell: "ds-page-shell",
  body: "ds-page-body",
  aside: "ds-page-aside",
  asideHead: "ds-page-aside-head",
  asideNav: "ds-page-aside-nav",
  asideFoot: "ds-page-aside-foot",
  navItem: "ds-page-nav-item",
  navItemActive: "ds-page-nav-item ds-page-nav-item-active",
  navChild: "ds-page-nav-child",
  navGroup: "ds-page-nav-group",
  main: "ds-page-main",
  content: "ds-page-content",
  contentFlush: "ds-page-content-flush",
  panel: "ds-page-panel",
  panelHead: "ds-page-panel-head",
  toolbar: "ds-page-toolbar",
  alert: "ds-page-alert",
  actions: "ds-page-actions",
};
